export const RESPONSE_TOOLBAR_LOCALE = {
    more: 'More',
};
